import require$$0, { existsSync } from 'fs';
import require$$1, { resolve } from 'path';
import require$$2 from 'os';
import require$$0$1 from 'crypto';

var main = {exports: {}};

const fs = require$$0;
const path = require$$1;
const os = require$$2;

const LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;

// Parser src into an Object
function parse (src) {
  const obj = {};

  // Convert buffer to string
  let lines = src.toString();

  // Convert line breaks to same format
  lines = lines.replace(/\r\n?/mg, '\n');

  let match;
  while ((match = LINE.exec(lines)) != null) {
    const key = match[1];

    // Default undefined or null to empty string
    let value = (match[2] || '');

    // Remove whitespace
    value = value.trim();

    // Check if double quoted
    const maybeQuote = value[0];

    // Remove surrounding quotes
    value = value.replace(/^(['"`])([\s\S]*)\1$/mg, '$2');

    // Expand newlines if double quoted
    if (maybeQuote === '"') {
      value = value.replace(/\\n/g, '\n');
      value = value.replace(/\\r/g, '\r');
    }

    // Add to object
    obj[key] = value;
  }

  return obj
}

function _log (message) {
  console.log(`[dotenv][DEBUG] ${message}`);
}

function _resolveHome (envPath) {
  return envPath[0] === '~' ? path.join(os.homedir(), envPath.slice(1)) : envPath
}

// Populates process.env from .env file
function config (options) {
  let dotenvPath = path.resolve(process.cwd(), '.env');
  let encoding = 'utf8';
  const debug = Boolean(options && options.debug);
  const override = Boolean(options && options.override);

  if (options) {
    if (options.path != null) {
      dotenvPath = _resolveHome(options.path);
    }
    if (options.encoding != null) {
      encoding = options.encoding;
    }
  }

  try {
    // Specifying an encoding returns a string instead of a buffer
    const parsed = DotenvModule.parse(fs.readFileSync(dotenvPath, { encoding }));

    Object.keys(parsed).forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(process.env, key)) {
        process.env[key] = parsed[key];
      } else {
        if (override === true) {
          process.env[key] = parsed[key];
        }

        if (debug) {
          if (override === true) {
            _log(`"${key}" is already defined in \`process.env\` and WAS overwritten`);
          } else {
            _log(`"${key}" is already defined in \`process.env\` and was NOT overwritten`);
          }
        }
      }
    });

    return { parsed }
  } catch (e) {
    if (debug) {
      _log(`Failed to load ${dotenvPath} ${e.message}`);
    }

    return { error: e }
  }
}

const DotenvModule = {
  config,
  parse
};

var config_1 = main.exports.config = DotenvModule.config;
main.exports.parse = DotenvModule.parse;
main.exports = DotenvModule;

var _a;
let configLoaded = Boolean((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.SKIP_CONFIG_LOAD);
/**
 * Loads the config file, walking up the directory tree until it finds one for the current environment.
 */
const loadConfigFile = () => {
    if (configLoaded) {
        return;
    }
    let cwd = process.cwd();
    while (true) {
        const configPath = resolve(cwd, `.${process.env.NODE_ENV}.env`);
        if (existsSync(configPath)) {
            config_1({ path: configPath });
            configLoaded = true;
            break;
        }
        cwd = resolve(cwd, '..');
        if (cwd === '/') {
            throw new Error(`No config file found for environment ${process.env.NODE_ENV}`);
        }
    }
};
const getConfig = (key, emptyValue = null) => {
    var _a, _b, _c, _d;
    if (!((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a[key]))
        loadConfigFile();
    // handle the case where the value is explicitly set to '[EMPTY]' when SSM is doing a dumb.
    if (((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b[key]) === '[EMPTY]')
        return emptyValue;
    return (_d = (_c = process === null || process === void 0 ? void 0 : process.env) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : emptyValue;
};

// Node.js core modules
var crypto = require$$0$1;


/**
 * The encryption algorithm (cipher) type to be used.
 * @type {String}
 * @const
 * @private
 */
var CIPHER_ALGORITHM = 'aes-256-ctr';


//
// Primary API
//

/**
 * An API to allow for greatly simplified AES-256 encryption and decryption using a passphrase of
 * any length plus a random Initialization Vector.
 * @exports aes256
 * @public
 */
var aes256 = {

  /**
   * Encrypt a clear-text message using AES-256 plus a random Initialization Vector.
   * @param {String} key  A passphrase of any length to used to generate a symmetric session key.
   * @param {String|Buffer} input  The clear-text message or buffer to be encrypted.
   * @returns {String|Buffer} A custom-encrypted version of the input.
   * @public
   * @method
   */
  encrypt: function(key, input) {
    if (typeof key !== 'string' || !key) {
      throw new TypeError('Provided "key" must be a non-empty string');
    }

    var isString = typeof input === 'string';
    var isBuffer = Buffer.isBuffer(input);
    if (!(isString || isBuffer) || (isString && !input) || (isBuffer && !Buffer.byteLength(input))) {
      throw new TypeError('Provided "input" must be a non-empty string or buffer');
    }

    var sha256 = crypto.createHash('sha256');
    sha256.update(key);

    // Initialization Vector
    var iv = crypto.randomBytes(16);
    var cipher = crypto.createCipheriv(CIPHER_ALGORITHM, sha256.digest(), iv);

    var buffer = input;
    if (isString) {
      buffer = Buffer.from(input);
    }

    var ciphertext = cipher.update(buffer);
    var encrypted = Buffer.concat([iv, ciphertext, cipher.final()]);

    if (isString) {
      encrypted = encrypted.toString('base64');
    }

    return encrypted;
  },

  /**
   * Decrypt an encrypted message back to clear-text using AES-256 plus a random Initialization Vector.
   * @param {String} key  A passphrase of any length to used to generate a symmetric session key.
   * @param {String|Buffer} encrypted  The encrypted message to be decrypted.
   * @returns {String|Buffer} The original plain-text message or buffer.
   * @public
   * @method
   */
  decrypt: function(key, encrypted) {
    if (typeof key !== 'string' || !key) {
      throw new TypeError('Provided "key" must be a non-empty string');
    }

    var isString = typeof encrypted === 'string';
    var isBuffer = Buffer.isBuffer(encrypted);
    if (!(isString || isBuffer) || (isString && !encrypted) || (isBuffer && !Buffer.byteLength(encrypted))) {
      throw new TypeError('Provided "encrypted" must be a non-empty string or buffer');
    }

    var sha256 = crypto.createHash('sha256');
    sha256.update(key);

    var input = encrypted;
    if (isString) {
      input = Buffer.from(encrypted, 'base64');

      if (input.length < 17) {
        throw new TypeError('Provided "encrypted" must decrypt to a non-empty string or buffer');
      }
    } else {
      if (Buffer.byteLength(encrypted) < 17) {
        throw new TypeError('Provided "encrypted" must decrypt to a non-empty string or buffer');
      }
    }

    // Initialization Vector
    var iv = input.slice(0, 16);
    var decipher = crypto.createDecipheriv(CIPHER_ALGORITHM, sha256.digest(), iv);

    var ciphertext = input.slice(16);

    var output;
    if (isString) {
      output = decipher.update(ciphertext) + decipher.final();
    } else {
      output = Buffer.concat([decipher.update(ciphertext), decipher.final()]);
    }

    return output;
  }

};




/**
 * Create a symmetric cipher with a given passphrase to then encrypt/decrypt data symmetrically.
 * @param {String} key  A passphrase of any length to used to generate a symmetric session key.
 * @public
 * @constructor
 */
function AesCipher(key) {
  if (typeof key !== 'string' || !key) {
    throw new TypeError('Provided "key" must be a non-empty string');
  }

  /**
   * A passphrase of any length to used to generate a symmetric session key.
   * @member {String} key
   * @readonly
   */
  Object.defineProperty(this, 'key', { value: key });

}

/**
 * Encrypt a clear-text message using AES-256 plus a random Initialization Vector.
 * @param {String} plaintext  The clear-text message to be encrypted.
 * @returns {String} A custom-encrypted version of the input.
 * @public
 * @method
 */
AesCipher.prototype.encrypt = function(plaintext) {
  return aes256.encrypt(this.key, plaintext);
};

/**
 * Decrypt an encrypted message back to clear-text using AES-256 plus a random Initialization Vector.
 * @param {String} encrypted  The encrypted message to be decrypted.
 * @returns {String} The original plain-text message.
 * @public
 * @method
 */
AesCipher.prototype.decrypt = function(encrypted) {
  return aes256.decrypt(this.key, encrypted);
};




//
// API Extension
//


/**
 * Create a symmetric cipher with a given passphrase to then encrypt/decrypt data symmetrically.
 * @param {String} key  A passphrase of any length to used to generate a symmetric session key.
 * @returns {AesCipher}
 * @public
 * @method
 */
aes256.createCipher = function(key) {
  return new AesCipher(key);
};




//
// Export the API
//

var aes256_1 = aes256;

// @ts-ignore - Untyped Module
const encryptString = (text) => aes256_1.encrypt(getConfig('aes256_encryption_key'), text);
const decryptString = (encryptedText) => aes256_1.decrypt(getConfig('aes256_encryption_key'), encryptedText);

const DEFAULT_PAGINATION_SIZE = 50;
const DEFAULT_PAGINATION_PAGE = 1;
const PAGINATION_SIZE_LARGE = 10000;
const DEFAULT_RESPONSE = {
    offset: 0,
    limit: DEFAULT_PAGINATION_SIZE
};
const convertPagination = (pagination) => {
    if (!pagination)
        return DEFAULT_RESPONSE;
    const { page = DEFAULT_PAGINATION_PAGE, size = DEFAULT_PAGINATION_SIZE } = pagination;
    return {
        limit: size,
        offset: (page - 1) * size
    };
};

const SHIPPING_CARRIERS = {
    UPS: 'ups',
    USPS: 'usps',
    FEDEX: 'fedex',
    DHL: 'dhl',
    AMAZON: 'amazon',
};
const getTrackingLink = (carrier, trackingNumber) => {
    if (!carrier || !trackingNumber)
        return null;
    switch (carrier.toLowerCase()) {
        case 'ups':
            return `https://www.ups.com/track?loc=en_US&tracknum=${trackingNumber}`;
        case 'usps':
            return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`;
        case 'fedex':
            return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`;
        case 'dhl':
            return `https://www.dhl.com/us-en/home/tracking/tracking-ecommerce.html?submit=1&tracking-id=${trackingNumber}`;
        case 'amazon':
            return `https://track.amazon.com/tracking/${trackingNumber}`;
    }
    return null;
};

const ASSET_TYPES = {
    PRODUCT: 'product',
    ENHANCEMENT_STORE: 'enhancement_store',
    PROFILE_IMAGE: 'profile_image',
    NOTIFICATION_IMAGE: 'notification_image',
    VENDOR: 'vendor',
    PROGRESS_PHOTOS: 'progress_photos',
    CSV: 'csv',
    LICENSE_PHOTO: 'license_photo',
};

const ROLES = {
    ADMIN: 'admin',
    ORDER_ADMIN: 'order admin',
    ESTHETICIAN: 'esthetician',
    ESTHETICIAN_STUDENT: 'esthetician_student',
    ESTHETICIAN_PENDING: 'esthetician pending',
    CUSTOMER: 'customer',
    GUEST: 'guest',
    UNASSIGNED: 'unassigned',
};
/**
 * TODO: Switch to proper RBAC instead of just this weighted system
 */
const ROLE_PERMISSION_LEVELS = {
    [ROLES.ADMIN]: 100,
    [ROLES.ORDER_ADMIN]: 80,
    [ROLES.ESTHETICIAN]: 50,
    [ROLES.ESTHETICIAN_STUDENT]: 50,
    [ROLES.ESTHETICIAN_PENDING]: 50,
    [ROLES.CUSTOMER]: 10,
    [ROLES.GUEST]: 0,
};
const TIERS = {
    NONE: 'none',
    // SaaS offering tiers
    ESTHETICIAN_BASIC: 'esthetician_basic',
    ESTHETICIAN_ELITE: 'esthetician_elite',
    ESTHETICIAN_PLUS: 'esthetician_plus',
    CUSTOMER_PLUS: 'customer_plus',
};
const VALID_TIERS_FOR_ROLE = {
    [ROLES.ADMIN]: [TIERS.NONE],
    [ROLES.ORDER_ADMIN]: [TIERS.NONE],
    [ROLES.ESTHETICIAN]: [
        TIERS.NONE,
        TIERS.ESTHETICIAN_BASIC,
        TIERS.ESTHETICIAN_PLUS,
        TIERS.ESTHETICIAN_ELITE,
    ],
    [ROLES.ESTHETICIAN_STUDENT]: [
        TIERS.NONE,
        TIERS.ESTHETICIAN_BASIC,
        TIERS.ESTHETICIAN_PLUS,
        TIERS.ESTHETICIAN_ELITE,
    ],
    [ROLES.ESTHETICIAN_PENDING]: [TIERS.NONE],
    [ROLES.CUSTOMER]: [TIERS.NONE, TIERS.CUSTOMER_PLUS],
};
const BUSINESS_ROLES = {
    ADMIN: 'business admin',
    OWNER: 'business owner',
    ESTHETICIAN: 'esthetician',
};
const BUSINESS_TIERS = {
    SOLO: 'Solo',
    TEAM: 'Team',
};

const SUBSCRIPTION_STATUSES = {
    PENDING: 'pending',
    ACTIVE: 'active',
    ENDING: 'ending',
    ENDED: 'ended',
    TRIALING: 'trialing',
    UNPAID: 'unpaid',
    DOWNGRADING: 'downgrading',
    CHANGING_BLLING_INTERVAL: 'changing_billing_interval',
};
const SUBSCRIPTION_TIERS = {
    ESTHETICIAN_BASIC: 'esthetician_basic',
    ESTHETICIAN_PLUS: 'esthetician_plus',
    ESTHETICIAN_ELEVATED: 'esthetician_elevated',
    ESTHETICIAN_ELITE: 'esthetician_elite',
    // For use in testing
    ESTHETICIAN_BASIC_DAILY: 'esthetician_basic_daily',
    ESTHETICIAN_PLUS_DAILY: 'esthetician_plus_daily',
    ESTHETICIAN_ELEVATED_DAILY: 'esthetician_elevated_daily',
    ESTHETICIAN_ELITE_DAILY: 'esthetician_elite_daily',
    ESTHETICIAN_CANCELED: 'esthetician_canceled', // The Cancelled Plan
};
const ACTIVE_ESTHETICIAN_SUBSCRIPTION_TIERS = [
    SUBSCRIPTION_TIERS.ESTHETICIAN_BASIC,
    SUBSCRIPTION_TIERS.ESTHETICIAN_PLUS,
    SUBSCRIPTION_TIERS.ESTHETICIAN_ELEVATED,
    SUBSCRIPTION_TIERS.ESTHETICIAN_ELITE,
];
const INVOICE_STATUSES = {
    PAID: 'paid',
    CANCELLED: 'cancelled',
    UNPAID: 'unpaid',
    REFUNDED: 'refunded',
};
const ACTIVE_SUBSCRIPTION_STATUSES = [
    SUBSCRIPTION_STATUSES.ACTIVE,
    SUBSCRIPTION_STATUSES.TRIALING,
    SUBSCRIPTION_STATUSES.ENDING,
    SUBSCRIPTION_STATUSES.CHANGING_BLLING_INTERVAL,
    // TODO: Consider if this should be here.
    SUBSCRIPTION_STATUSES.UNPAID,
    SUBSCRIPTION_STATUSES.DOWNGRADING,
];
const PRODUCT_SUBSCRIPTIONS_TIERS = {
    SIX_WEEKS: 'six_weeks',
    EIGHT_WEEKS: 'eight_weeks',
    TEN_WEEKS: 'ten_weeks',
    TWELVE_WEEKS: 'twelve_weeks',
    SIXTEEN_WEEKS: 'sixteen_weeks',
};
const SUBSCRIPTION_INTERVALS = {
    DAY: 'day', // For local testing
    MONTH: 'month',
    QUARTER: 'quarter',
    YEAR: 'year',
    WEEK: 'week',
};
const PRODUCT_INTERVAL_OPTIONS = [
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS.SIX_WEEKS,
        value: '6 weeks (save 10%)',
        discount: 0.1,
        interval: 6,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS.EIGHT_WEEKS,
        value: '8 weeks (save 5%)',
        discount: 0.05,
        interval: 8,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS.TEN_WEEKS,
        value: '10 weeks (save 5%)',
        discount: 0.05,
        interval: 10,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS.TWELVE_WEEKS,
        value: '12 weeks (save 5%)',
        discount: 0.05,
        interval: 12,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS.SIXTEEN_WEEKS,
        value: '16 weeks (save 5%)',
        discount: 0.05,
        interval: 16,
    },
];
// For local testing
const PRODUCT_SUBSCRIPTIONS_TIERS_DAILY = {
    ONE_DAY: 'one_day',
    TWO_DAY: 'two_day',
    THREE_DAY: 'three_day',
    FOUR_DAY: 'four_day',
    FIVE_DAY: 'five_day',
};
const PRODUCT_INTERVAL_OPTIONS_DAILY = [
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS_DAILY.ONE_DAY,
        value: '1 day (save 10%)',
        discount: 0.1,
        interval: 1,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS_DAILY.TWO_DAY,
        value: '2 days (save 5%)',
        discount: 0.05,
        interval: 2,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS_DAILY.THREE_DAY,
        value: '3 days (save 5%)',
        discount: 0.05,
        interval: 3,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS_DAILY.FOUR_DAY,
        value: '4 days (save 5%)',
        discount: 0.05,
        interval: 4,
    },
    {
        id: PRODUCT_SUBSCRIPTIONS_TIERS_DAILY.FIVE_DAY,
        value: '5 days (save 5%)',
        discount: 0.05,
        interval: 5,
    },
];

const getNumericValueForSubscriptionTier = (tier) => {
    switch (tier) {
        case SUBSCRIPTION_TIERS.ESTHETICIAN_BASIC:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_BASIC_DAILY:
            return 1;
        case SUBSCRIPTION_TIERS.ESTHETICIAN_PLUS:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_PLUS_DAILY:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELEVATED:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELEVATED_DAILY:
            return 2;
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELITE:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELITE_DAILY:
            return 3;
        default:
            return 0;
    }
};
const getSubscriptionChangeType = (previous, updated) => {
    if (previous === updated) {
        return 'unchanged';
    }
    if (getNumericValueForSubscriptionTier(updated) >= // When they're the same this is typically someone restarting their subscription before it downgraded.
        getNumericValueForSubscriptionTier(previous)) {
        return 'upgrade';
    }
    return 'downgrade';
};
const getNormalBillingInterval = (interval) => {
    switch (interval) {
        case 'day':
            return 'daily';
        default:
            return `${interval}ly`;
    }
};
const getNormalPlanName = (plan) => {
    if (plan === SUBSCRIPTION_TIERS.ESTHETICIAN_BASIC)
        return 'Basic';
    if (plan === SUBSCRIPTION_TIERS.ESTHETICIAN_ELEVATED ||
        plan === SUBSCRIPTION_TIERS.ESTHETICIAN_PLUS)
        return 'Elevated';
    if (plan === SUBSCRIPTION_TIERS.ESTHETICIAN_ELITE)
        return 'Elite';
};

/**
 * Does the user have the given role or higher?
 * @param role
 * @param user
 * @returns
 */
const validateRolePermission = (role, user) => {
    const userRoles = (user && user.roles) || [];
    if (userRoles.includes(role)) {
        return true;
    }
    return userRoles.some(userRole => ROLE_PERMISSION_LEVELS[userRole] >= ROLE_PERMISSION_LEVELS[role]);
};
/**
 * A helper function that takes the current user and a user to check whether
 * the actor has permission to act on the target.
 * @param actor The currently Authenticated User
 * @param user The user to check for permissions against
 * @param isBusinessClient Is the actor a business client
 * @returns Boolean indicating if the actor has permission to view the user
 */
const hasUserPermission = async (actor, user, isBusinessClient = false // Is the actor a business client
) => {
    var _a;
    // If the current user is an admin, they can acceess all users
    if ((_a = actor === null || actor === void 0 ? void 0 : actor.roles) === null || _a === void 0 ? void 0 : _a.includes(ROLES.ADMIN)) {
        return true;
    }
    // If the current user belongs to a business
    if (isBusinessClient) {
        return true;
    }
    // An Esthetician can access all of their own users
    if (user.estheticianId === actor.id) {
        return true;
    }
    // A Customer can access their own user
    return actor.id === user.id;
};
/**
 * @param tier The esthetician tier
 * @returns The tier the client should be created at
 */
const getBaseUserTierFromEstheticianTier = (tier) => {
    switch (tier) {
        case TIERS.ESTHETICIAN_ELITE:
        case TIERS.ESTHETICIAN_PLUS:
            return TIERS.CUSTOMER_PLUS;
        default:
            return TIERS.NONE;
    }
};
const getTierFromSubscriptionPlan = (plan) => {
    switch (plan) {
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELITE:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELITE_DAILY:
            return TIERS.ESTHETICIAN_ELITE;
        case SUBSCRIPTION_TIERS.ESTHETICIAN_PLUS:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_PLUS_DAILY:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELEVATED:
        case SUBSCRIPTION_TIERS.ESTHETICIAN_ELEVATED_DAILY:
            return TIERS.ESTHETICIAN_PLUS;
        case SUBSCRIPTION_TIERS.ESTHETICIAN_BASIC:
            return TIERS.ESTHETICIAN_BASIC;
        default:
            return TIERS.NONE;
    }
};

/**
 * @description A base error that all other errors inherit from, includes the status code and message
 */
class PompApiError extends Error {
    constructor(message) {
        super(message);
        this.name = 'PompApiError';
        this.status = 500;
    }
}
/**
 * @description Insufficient permissions error
 */
class AccessDeniedError extends PompApiError {
    constructor(message = 'Access Denied: Insufficient Permissions') {
        super(message);
        this.name = 'AccessDeniedError';
        this.status = 403;
    }
}
class NotFoundError extends PompApiError {
    constructor(message = 'Access Denied: Not Found') {
        super(message);
        this.name = 'NotFoundError';
        this.status = 403;
    }
}
/**
 * @description Invalid Request Error
 */
class ValidationError extends PompApiError {
    constructor(message = 'Invalid Request: Invalid Parameters') {
        super(message);
        this.name = 'ValidationError';
        this.status = 500;
    }
}

/**
 * A wrapper that validates that the currently authenticated user is
 * eligible to complete this function and if so executes it.
 *
 * @param func The function to execute if it passes the role check
 * @param requiredRole The minimum required role to access this function.
 * @returns The handler function
 */
const authenticationWrapper = (func, requiredRole) => (root, args, context) => {
    // No role required, just execute the function
    if (!requiredRole)
        return func({ root, args, context });
    // The user isn't signed in, throw an error
    if (!context.user)
        throw new ValidationError();
    // Check if the user has the required role.
    if (!validateRolePermission(requiredRole, context.user))
        throw new ValidationError();
    return func({ root, args, context });
};

// Used with Luxon to ensure that all processing times are in the same time zone
const DEFAULT_TIME_ZONE = 'America/Denver';

const BRAND_EDUCATION_FORMATS = {
    PREWORK: 'Pre-work',
    LIVE_EDUCATION: 'Live Education',
    RECORDED_VIDEO: 'Recorded Video',
    ONLINE_CERTIFICATION: 'Online Certification',
    SUPPLEMENTAL_EDUCATION: 'Supplemental Education',
};
const BRAND_EDUCATION_TYPES = {
    REQUIRED_EDUCATION: 'Required Education',
    ADDITIONAL_RESOURCES: 'Additional Resources',
};
const BRAND_EDUCATION_PRICE_POINTS = {
    AFFORDABLE: '$ - affordable',
    MODERATE: '$$ - moderate',
    LUXURY: '$$$ - luxury',
};
const HOW_HELPFUL = {
    NOT_AT_ALL: 'Not at all helpful',
    SOMEWHAT: 'Somewhat helpful',
    MODERATE: 'Moderately helpful',
    VERY: 'Very helpful',
    EXTREMELY: 'Extremely helpful'
};
const BRAND_EDUCATION_TIME = {
    THIRTYORLESS: '30 min or less',
    THIRTYSIXTY: '31-60 min',
    SIXTYNINETY: '61-90 min',
    NINETYONETWENTY: '91-120 min',
    ONETWENTYPLUS: '120+ min'
};

const ADD_TO = {
    MY_CART: 'My Cart',
    CLIENTS_CART: "A Client's Cart",
};
const CART_SOURCE = {
    PRODUCT_SEARCH: 'product_search',
    ENHANCEMENT_STORE: 'enhancement_store',
    ROUTINE: 'routine',
    PRO_STORE: 'pro_store',
    REORDER: 'reorder',
    SUBSCRIPTION: 'subscription',
    ADDED_DURING_INVITE: 'added_during_invite',
    ASK_MY_ESTIE: 'ask_my_estie',
    BULK_ADD_TO_ALL_CLIENTS: 'bulk_add_to_all_clients',
    QUICK_ADD: 'quick_add',
};
const ADD_TO_CART_OPTIONS = [ADD_TO.MY_CART, ADD_TO.CLIENTS_CART];

const COMMISSION_TYPE = {
    ORDER: 'order',
    BONUS: 'bonus',
    REFERRAL: 'referral',
    ADJUSTMENT: 'adjustment'
};
const COMMISSION_BONUS_TYPE = {
    FIXED: 'fixed',
    PERCENT: 'percent'
};
const COMMISSION_BONUS_TRIGGER_TYPE = {
    total_orders: 'total_orders',
    total_value: 'total_value'
};
const COMMISSION_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    CANCELLED: 'cancelled'
};
const COMMISSION_PLAN_STATUS = {
    ACTIVE: 'active',
    CANCELLED: 'cancelled'
};
const COMMISSION_PAYMENT_STATUS = {
    PENDING: 'pending',
    PAID: 'paid',
    CANCELLED: 'cancelled'
};

const calculateOrderCommissionAmount = (
// The elligible commission value is the total value of the order minus any discounts or giftcard purchases.
elligibleCommissionValue, commissionPercentage) => {
    // Calculate the commission amount based on the commission percentage.
    const commissionAmount = elligibleCommissionValue * commissionPercentage;
    // Ensure the commission amount is a valid, not negative value
    if (isNaN(commissionAmount) || commissionAmount < 0)
        return 0;
    // Return the commission amount.
    return commissionAmount;
};
const calculateEligibleBonuses = (filter, 
// The value that is used to calculate the bonus amount for percentage bonuses.
totalNetSales, 
// The bonuses to filter and calculate.
bonuses) => bonuses
    // Ensure the bonuses is for the correct trigger and the total net sales is above the threshold.
    .filter(bonus => bonus.trigger &&
    bonus.threshold &&
    bonus.trigger === filter.trigger &&
    filter.triggerValue >= bonus.threshold)
    .map(bonus => ({
    id: bonus.id,
    name: bonus.name,
    threshold: filter.triggerValue,
    amount: 
    // If the bonus is a fixed amount, return the amount, otherwise return the percentage of the total net sales.
    bonus.type === COMMISSION_BONUS_TYPE.FIXED
        ? bonus.amount
        : totalNetSales * bonus.amount,
}));

const CREDIT_TYPES = {
    giftCard: 'Gift card',
    credit: 'credit',
    debit: 'debit',
    reward: 'reward',
    orderCredit: 'order credit',
    estheticianReferral: 'esthetician referral',
    firstOrderBonus: 'first order bonus',
    monthlyIncentive: 'monthly incentive',
};
const CREDIT_STATUSES = {
    active: 'ACTIVE',
    inuse: 'INUSE',
    inactive: 'INACTIVE',
    redeemed: 'REDEEMED',
    partiallyRedeemed: 'PARTIALLY REDEEMED',
    valid: 'VALID',
    expired: 'EXPIRED',
};
const CREDIT_TYPE_OPTIONS = [
    { type: CREDIT_TYPES.giftCard, label: 'Gift card' },
    { type: CREDIT_TYPES.reward, label: 'Reward' },
    { type: CREDIT_TYPES.orderCredit, label: 'Order credit' },
    { type: CREDIT_TYPES.estheticianReferral, label: 'Esthetician referral' },
    { type: CREDIT_TYPES.firstOrderBonus, label: 'First order bonus' },
    { type: CREDIT_TYPES.monthlyIncentive, label: 'Monthly incentive' },
];

const EMAIL_TEMPLATE_SENDERS = {
    POMP_NOREPLY: 'pomp_noreply',
    POMP_ORDERS: 'pomp_orders',
    POMP_ESTHETICIANS: 'pomp_estheticians',
    ESTHETICIAN: 'esthetician',
};
const EMAIL_TEMPLATE_KEYS = {
    // Admin Emails
    ADMIN_NEW_DIRECT_CLIENT: 'admin_new_direct_client',
    ADMIN_BACK_IN_STOCK: 'admin_back_in_stock',
    ADMIN_PAYMENT_FAILED: 'admin_payment_failed',
    // Client Emails
    CLIENT_INVITED_BY_ESTHETICIAN: 'client_invited',
    IMPORTED_CLIENT_INVITE: 'imported-client-invite',
    ESTHETICIAN_NEW_CLIENT: 'esthetician_new_client',
    CLIENT_ACCEPTED_INVITE: 'client_accepted_invite',
    ASK_MY_ESTIE_CONFIRM: 'ask_my_estie_confirm',
    ESTIE_APPROVED_REQUEST: 'product_request_approved',
    ESTIE_BULK_EMAIL_REQUEST: 'bulk_email_request',
    CLIENT_HAS_NOT_PURCHASED: 'client_has_not_purchased',
    // ORDER EMAILS
    ORDER_CONFIRMATION: 'order_confirmation',
    GIFTCARD_DETAILS: 'giftcard_details',
    ORDER_NOTIFICATION: 'order_notification',
    // PRODUCT EMAILS
    BACK_IN_STOCK: 'back_in_stock',
    ESTIE_ADD_PRODUCT_TO_CART: 'estie_add_product_to_cart',
    // REFERRAL EMAILS
    EARNED_REFERRAL_CREDIT: 'earned_referral_credit',
    // ROUTINES
    ROUTINE_ACTIVATED: 'routine_activated',
    // SHIPMENTS
    SHIPMENT: 'shipment',
    BACKORDERED_SHIPMENT: 'backordered_shipment',
    // SUBSCRIPTIONS
    SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
    SUBSCRIPTION_REMINDER: 'subscription_reminder',
    SUBSCRIPTION_DOWNGRADE: 'subscription_downgrade',
    SUBSCRIPTION_UPGRADE_ELEVATED: 'subscription_elevated',
    SUBSCRIPTION_UPGRADE_ELITE: 'subscription_elite',
    SUBSCRIPTION_PRODUCT: 'subscription_product',
    SUBSCRIPTION_UPDATED: 'subscription_updated',
    SUBSCRIPTION_INVOICE_PAID: 'subscription_invoice_paid',
    SUBSCRIPTION_INVOICE_PAYMENT_FAILED: 'subscription_invoice_payment_failed',
};

const ESTHETICIAN_ONBOARDING_PROGRESS_STATUS = {
    IN_PROGRESS: 'inProgress',
    COMPLETED: 'completed',
    ABANDONED: 'abandoned',
};
const ESTHETICIAN_ONBOARDING_PAGES = {
    LICENSE: 'license',
    INVITE: 'invite',
    ELEVATE: 'elevate',
    CLIENTS: 'clients',
    FAVORITES: 'favorites',
    BRANDS: 'brands',
    PRO_PROFILE: 'pro-profile',
    GROW_BUSINESS: 'grow-business',
    SCHEDULE: 'schedule',
};

const FEATURE_FLAGS = {
    // Enhancement Store
    ENHANCEMENTS_STORE: 'ENHANCEMENTS_STORE', // Who can view the enhancements store
    // Product Management
    MANAGE_PRODUCTS: 'MANAGE_PRODUCTS', // Fully manage products, vendors and categories
    PRODUCT_SEARCH: 'PRODUCT_SEARCH', // More basic product search for estheticians. Can't edit products.
    // Promo Codes
    MANAGE_PROMOS: 'MANAGE_PROMOS',
    // Order Management
    ORDER_SEARCH: 'ORDER_SEARCH', // Order search page
    ORDER_SEARCH_ADVANCED: 'ORDER_SEARCH_ADVANCED', // Additional options and filters for admins
    MANAGE_SHIPMENTS: 'MANAGE_SHIPMENTS', // Create shipments and send tracking emails
    // User Management
    USER_SEARCH: 'USER_SEARCH', // User search page
    MANAGE_USERS: 'MANAGE_USERS', // Can view and edit user details
    MANAGE_USERS_ADVANCED: 'MANAGE_USERS_ADVANCED', // Additional options for admins
    MESSAGING: 'MESSAGING', // Esthetician messaging
    ASSIGN_USERS: 'ASSIGN_USERS', // Can assign users to esties
    // User Features
    VIEW_NOTES: 'VIEW_NOTES', // View notes for users
    MANAGE_NOTES: 'MANAGE_NOTES', // Manage notes for users
    VIEW_ROUTINES: 'VIEW_ROUTINES', // View routines for users
    MANAGE_ROUTINES: 'MANAGE_ROUTINES', // Manage routines for users
    ASSIGN_ROUTINES: 'ASSIGN_ROUTINES', // Assign routines to users
    PUBLIC_ROUTINES: 'PUBLIC_ROUTINES', // Create public routines
    TREATMENT_ROOM: 'TREATMENT_ROOM', // Treatment room
    VIEW_SURVEYS: 'VIEW_SURVEYS', // View surveys for users
    MANAGE_CLIENT_CART: 'MANAGE_CLIENT_CART', // Manage client cart
    VIEW_DOCUMENTS: 'VIEW_DOCUMENTS', // View documents for users
    // Reporting
    VIEW_REPORTS: 'REPORTS', // View reports page
    DASHBOARDS: 'DASHBOARDS', // View esthetican dashboard
    // ACCOUNT
    MANAGE_ACCOUNT: 'MANAGE_ACCOUNT', // View account page
    REFER_AND_EARN: 'REFER_AND_EARN', // View refer and earn page
    ORDER_HISTORY: 'ORDER_HISTORY',
    CART: 'CART', // View cart
    CHECKOUT: 'CHECKOUT', // View checkout
    AUTH: 'AUTH', // View auth pages (Should only be guest users)
    MANAGE_SUBSCRIPTIONS: 'MANAGE_SUBSCRIPTIONS', // View subscriptions page
    ADMIN_SUBSCRIPTIONS: 'ADMIN_SUBSCRIPTIONS', // View subscriptions page for admins
    MANAGE_PREFERENCES: 'MANAGE_PREFERENCES', // View preferences page
    MANAGE_NOTIFICATIONS: 'MANAGE_NOTIFICATIONS',
    MANAGE_CUSTOM_LINKS: 'MANAGE_CUSTOM_LINKS', // View Custom Links page
    // COMMISSION
    MANAGE_COMMISSION: 'MANAGE_COMMISSION', // Manage esthetician commission
    // External Links
    MARKETING_LINKS: 'MARKETING_LINKS',
    RESOURCES: 'RESOURCES',
    ELEVATED_RESOURCES: 'ELEVATED_RESOURCES',
    TRAINING: 'TRAINING',
    TOUR: 'TOUR',
    // Esthetician Onboarding
    ONBOARDING: 'ONBOARDING', // Guided onboarding for estheticians
    GEOF_ELEVATED_SUBSCRIPTION: 'GEOF_ELEVATED_SUBSCRIPTION', // Geof's elevated subscription test
    MANAGE_ONBOARDING: 'MANAGE_ONBOARDING', // Admins onboarding for esties
    // Esthetician License
    MANAGE_LICENSE: 'MANAGE_LICENSE', // License management for estheticians
    // Pro Store
    PRO_STORE: 'PRO_STORE',
    ESTHE_PRO_STORE: 'ESTHE_PRO_STORE',
    CLIENT_PRO_STORE_NAV_ITEM: 'CLIENT_PRO_STORE_NAV_ITEM',
    // Brand Education
    BRAND_EDUCATION: 'BRAND_EDUCATION',
    // Tasks
    TASKS: 'TASKS',
    // Integrations
    MANAGE_INTEGRATIONS: 'MANAGE_INTEGRATIONS',
    // AI Features
    AI_GENERATE_MESSAGES: 'AI_GENERATE_MESSAGES',
    // PRO file
    MANAGE_PROFILE: 'MANAGE_PROFILE',
    MANAGE_PUBLIC_PROFILE: 'MANAGE_PUBLIC_PROFILE',
    // PODIUM CHAT
    PODIUM_CHAT: 'PODIUM_CHAT',
    // Find esties
    FIND_ESTIES: 'FIND_ESTIES',
    // Brand Rules
    MANAGE_ESTIE_BRAND_RULES: 'MANAGE_ESTIE_BRAND_RULES',
    // Wishlists
    MANAGE_WISHLISTS: 'MANAGE_WISHLISTS',
    // Retail Feature Flags
    RETAIL_USE_TERMINAL: 'RETAIL_USE_TERMINAL',
    // Manage store landing page
    MANAGE_STORE_LANDING_PAGE: 'MANAGE_STORE_LANDING_PAGE',
    // Photographic journey
    PROGRESS_PHOTOS: 'PROGRESS_PHOTOS',
    // Product required on Invite Client Form
    PRODUCT_REQUIRED_INVITE_FORM: 'PRODUCT_REQUIRED_INVITE_FORM',
    // Manage User credits
    MANAGE_CREDITS: 'MANAGE_CREDITS',
    // Add to all carts
    ADD_TO_ALL_CARTS: 'ADD_TO_ALL_CARTS',
    // CANCELED SUBSCRIPTION
    CANCELED_SUBSCRIPTION: 'CANCELED_SUBSCRIPTION',
};
/** Dictates how a feature flag works. */
const FEATURE_FLAG_TYPES = {
    /** In descending order of specificity: */
    /**
     * The most specific feature flag whose rule applies to a
     * specific user. When a feature flag is of type USER, the
     * rule must be the user ID to whom the feature flag applies.
     */
    USER: 'USER',
    /**
     * A feature flag whose rule applies to users in a specific
     * application role (i.e, 'admin', 'esthetician', 'customer').
     * When a feature flag is of type ROLE, the rule must be the
     * role string to which the feature flag applies.
     */
    ROLE: 'ROLE',
    /**
     * A feature flag whose rule applies to users in a specific
     * tier. When a feature flag is of type TIER, the rule must
     * be the tier string to which the feature flag applies.
     */
    TIER: 'TIER',
    /**
     * A feature flag whose rule applies to all users. Useful for
     * experimental features.
     */
    GLOBAL: 'GLOBAL',
    /**
     * A feature flag whose rule applies to users in a specific
     * business type. When a feature flag is of type BUSINESSPERMISSION, the rule must
     * be the tier string to which the feature flag applies.
     */
    BUSINESS_PERMISSIONS: 'BUSINESS_PERMISSIONS',
    BUSINESS_PERMISSIONS_TIERS: 'BUSINESS_PERMISSIONS_TIERS',
};

const INTEGRATIONS = {
    square: 'square',
    zapier: 'zapier',
};
const INTEGRATION_AUTH_TYPES = {
    oauth: 'oauth',
    key: 'key',
};
const IMPORT_STATUS = {
    IMPORTED: 'imported',
    SKIPPED: 'skipped',
    ERRORED: 'errored',
};
const VALID_INTEGRATIONS = Object.values(INTEGRATIONS);

const LICENSE_STATUSES = {
    PENDING: 'pending',
    APPROVED: 'approved',
    DENIED: 'denied',
    EXPIRED: 'expired'
};
const LICENSE_APPROVAL = {
    AUTOMATED: 'automated',
    MANUAL: 'manual',
    NEEDS_VERIFICATION: 'needs verification',
};
const CLIENT_COUNT = [
    '0 - 20',
    '21 - 40',
    '41 - 60',
    '61 - 80',
    '81 - 100',
    '100+',
];
const CLIENT_COUNT_OPTIONS = CLIENT_COUNT.map(count => ({ id: count, title: count }));

const ORDER_COMMISSION = {
    DEFAULT: 'Direct',
    PRO: 'Pro',
};
const ORDER_NUMBER = {
    ALPHABET: '1234567890',
    LENGTH: 10,
};

const DEFAULT_PRODUCT_IMAGE = 'https://pomp-staging-assets-bucket.s3.amazonaws.com/public/product/54dd6448-0562-4e47-8d72-5c07f4cb00ba.png';
const TAX_CODE = {
    GIFTCARDS: 'txcd_10502000',
    GENERAL_GOODS: 'txcd_99999999',
};

const DISCOUNT_TYPE = {
    DOLLARS: 'Dollars',
    PERCENT: 'Percent',
};
const DISCOUNT_TYPE_OPTIONS = [DISCOUNT_TYPE.DOLLARS, DISCOUNT_TYPE.PERCENT];
const ENTITY_TYPE = {
    CATEGORY: 'category',
    VENDOR: 'vendor',
    PRODUCT: 'product',
};
const ENTITY_TYPE_OPTIONS = [
    { id: ENTITY_TYPE.CATEGORY, title: ENTITY_TYPE.CATEGORY },
    { id: ENTITY_TYPE.VENDOR, title: ENTITY_TYPE.VENDOR },
    { id: ENTITY_TYPE.PRODUCT, title: ENTITY_TYPE.PRODUCT }
];
const ROLE_OPTIONS = [
    { id: ROLES.CUSTOMER, title: ROLES.CUSTOMER },
    { id: ROLES.ESTHETICIAN, title: ROLES.ESTHETICIAN }
];
const TIER_OPTIONS = [
    { id: TIERS.CUSTOMER_PLUS, title: TIERS.CUSTOMER_PLUS },
    { id: TIERS.ESTHETICIAN_PLUS, title: TIERS.ESTHETICIAN_PLUS }
];

const SPECIALTY_OPTIONS = [
    'Acne scars',
    'Anti-aging',
    'Blackheads',
    'Combination skin',
    'Compromised skin barrier',
    'Cystic acne',
    'Dry skin',
    'Eczema',
    'Hormonal acne',
    'Hyperpigmentation',
    'Melasma',
    'Neck and jawline acne',
    'Oily skin',
    'Pregnancy safe',
    'Psoriasis',
    'Rosacea',
    'Teen acne'
];
const SERVICES_OPTIONS = [
    'Body treatments',
    'Body waxing',
    'Chemical peels',
    'Deep extractions',
    'Dermaplaning',
    'Facial treatments',
    'Facial waxing',
    'Gua Shua',
    'Hot stone therapy',
    'Hydrafacials',
    'Microblading',
    'Microdermabrasion',
    'Microneedling',
    'Virtual consultations'
];
const ESTHETICIAN_TAG_TYPES = {
    SERVICES_OFFERED: 'services offered',
    SPECIALTIES: 'specialties'
};

const RECOMMENDATION_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PURCHASED: 'purchased',
};

const CAMPAIGNS = {
    GIVE_25_GET_25: 'give25get25',
    GIVE_75_GET_75: 'give75get75',
    GIVE_0_GET_0: 'give0get0'
};

const ROUTINE_STATUSES = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
    DRAFT: 'draft',
};
const ROUTINE_TIMING = {
    MORNING: 'morning',
    AFTERNOON: 'afternoon',
    EVENING: 'evening',
    NIGHT: 'night',
    ANYTIME: 'anytime',
};

/** Ensure the routine is valid before we can activate it.*/
const isRoutineValid = (routine) => {
    var _a;
    if (!routine.title)
        return false;
    if (!((_a = routine === null || routine === void 0 ? void 0 : routine.steps) === null || _a === void 0 ? void 0 : _a.length))
        return false;
    const products = [];
    for (const step of routine.steps) {
        if (!step.title)
            return false;
        for (const recommendation of step.recommendations) {
            if (recommendation.product)
                products.push(recommendation.product);
        }
    }
    // At least one step has a recommendation product otherwise return false.
    if (!products.length)
        return false;
    return true;
};

const ORDER_SHIPMENT_STATUS = {
    PROCESSED: 'processed',
    SHIPPED: 'shipped',
    BACKORDERED: 'back_ordered'
};

const getQualifiedShortUrl = (shortUrl) => {
    const urlShortenerUrl = getConfig('url_shortener_url') || '';
    return `${urlShortenerUrl}/${shortUrl}`;
};

const CURRENT_SURVEY_VERSION = '3';
const SURVEY_QUESTION_TYPES = {
    CHOICE: 'choice',
    TEXT: 'text',
    CAPTURE: 'capture',
    PLACE_HOLDER: 'placeholder'
};
const SURVEY_QUESTION_SUB_TYPES = {
    CARD: 'card',
    NAME: 'name',
    EMAIL: 'email',
};

const CUSTOMER_STATUSES_DIRECT = {
    SURVEY_INCOMPLETE: 'survey_incomplete',
    READY_TO_ASSIGN: 'ready_to_assign',
    GUEST_CHECKOUT: 'guest_checkout',
};
const CUSTOMER_STATUSES_PRO = {
    INVITED: 'invited',
    IMPORTED: 'imported',
};
const CUSTOMER_STATUSES_DEFAULT = {
    PROFILE_COMPLETE: 'profile_complete',
    HAS_CART_ITEMS: 'has_cart_items',
    HAS_PURCHASED_ITEMS: 'has_purchased_items',
    HAS_LAPSED: 'has_lapsed',
    ARCHIVED: 'archived',
};
const CUSTOMER_STATUSES = {
    ...CUSTOMER_STATUSES_DIRECT,
    ...CUSTOMER_STATUSES_PRO,
    ...CUSTOMER_STATUSES_DEFAULT,
};
/**
 * This is a map of valid status changes for customers.
 * The key is the current status, and the value is an array of valid status changes. */
const VALID_CUSTOMER_STATUS_CHANGE_OUTCOMES = {
    [CUSTOMER_STATUSES.SURVEY_INCOMPLETE]: [CUSTOMER_STATUSES.READY_TO_ASSIGN],
    [CUSTOMER_STATUSES.READY_TO_ASSIGN]: [CUSTOMER_STATUSES.PROFILE_COMPLETE],
    [CUSTOMER_STATUSES.INVITED]: [CUSTOMER_STATUSES.PROFILE_COMPLETE],
    [CUSTOMER_STATUSES.IMPORTED]: [CUSTOMER_STATUSES.PROFILE_COMPLETE],
    [CUSTOMER_STATUSES.PROFILE_COMPLETE]: [CUSTOMER_STATUSES.HAS_CART_ITEMS],
    [CUSTOMER_STATUSES.HAS_CART_ITEMS]: [CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS],
    [CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS]: [CUSTOMER_STATUSES.HAS_LAPSED],
    [CUSTOMER_STATUSES.HAS_LAPSED]: [CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS],
    [CUSTOMER_STATUSES.GUEST_CHECKOUT]: [CUSTOMER_STATUSES.PROFILE_COMPLETE],
};
const PENDING_CUSTOMER_STATUS_CHANGE_OUTCOMES = {
    [CUSTOMER_STATUSES.SURVEY_INCOMPLETE]: [
        CUSTOMER_STATUSES.HAS_CART_ITEMS,
        CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS,
    ],
    [CUSTOMER_STATUSES.READY_TO_ASSIGN]: [
        CUSTOMER_STATUSES.HAS_CART_ITEMS,
        CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS,
    ],
    [CUSTOMER_STATUSES.INVITED]: [
        CUSTOMER_STATUSES.HAS_CART_ITEMS,
        CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS,
    ],
    [CUSTOMER_STATUSES.IMPORTED]: [
        CUSTOMER_STATUSES.HAS_CART_ITEMS,
        CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS,
    ],
};

const ESTHETICIAN_STATUSES = {
    ACCOUNT_CREATED: 'account_created',
    LICENSE_SUBMITTED: 'license_submitted',
    LICENSE_APPROVED: 'license_approved',
    LICENSE_REJECTED: 'license_rejected',
    ONBOARDED_CLIENTS: 'onboarded_clients',
    BECAME_EARNING: 'became_earning',
    BECAME_NON_EARNING: 'became_non_earning',
    ARCHIVED: 'archived',
    GUEST_CHECKOUT: 'guest_checkout',
};
/** This is a map of valid status changes for estheticians. The key is the current status, and the value is an array of valid status changes. */
const VALID_ESTHETICIAN_STATUS_CHANGE_OUTCOMES = {
    [ESTHETICIAN_STATUSES.ACCOUNT_CREATED]: [
        ESTHETICIAN_STATUSES.LICENSE_SUBMITTED,
    ],
    [ESTHETICIAN_STATUSES.LICENSE_SUBMITTED]: [
        ESTHETICIAN_STATUSES.LICENSE_APPROVED,
        ESTHETICIAN_STATUSES.LICENSE_REJECTED,
    ],
    [ESTHETICIAN_STATUSES.LICENSE_APPROVED]: [
        ESTHETICIAN_STATUSES.ONBOARDED_CLIENTS,
    ],
    [ESTHETICIAN_STATUSES.ONBOARDED_CLIENTS]: [
        ESTHETICIAN_STATUSES.BECAME_EARNING,
    ],
    [ESTHETICIAN_STATUSES.BECAME_EARNING]: [
        ESTHETICIAN_STATUSES.BECAME_NON_EARNING,
    ],
    [ESTHETICIAN_STATUSES.BECAME_NON_EARNING]: [
        ESTHETICIAN_STATUSES.BECAME_EARNING,
    ],
    [ESTHETICIAN_STATUSES.ARCHIVED]: [
        ESTHETICIAN_STATUSES.LICENSE_SUBMITTED,
        ESTHETICIAN_STATUSES.LICENSE_APPROVED,
        ESTHETICIAN_STATUSES.LICENSE_REJECTED,
        ESTHETICIAN_STATUSES.ONBOARDED_CLIENTS,
        ESTHETICIAN_STATUSES.BECAME_EARNING,
        ESTHETICIAN_STATUSES.BECAME_NON_EARNING,
    ],
    [ESTHETICIAN_STATUSES.GUEST_CHECKOUT]: [ESTHETICIAN_STATUSES.ACCOUNT_CREATED],
};
const PENDING_ESTHETICIAN_STATUS_CHANGE_OUTCOMES = {
    [ESTHETICIAN_STATUSES.LICENSE_SUBMITTED]: [
        ESTHETICIAN_STATUSES.ONBOARDED_CLIENTS,
        ESTHETICIAN_STATUSES.BECAME_EARNING,
    ],
};

const ESTHETICIAN_SAFE_CUSTOMER_STATUSES = [
    CUSTOMER_STATUSES.ARCHIVED,
    CUSTOMER_STATUSES.HAS_CART_ITEMS,
    CUSTOMER_STATUSES.HAS_LAPSED,
    CUSTOMER_STATUSES.HAS_PURCHASED_ITEMS,
    CUSTOMER_STATUSES.INVITED,
    CUSTOMER_STATUSES.IMPORTED,
    CUSTOMER_STATUSES.PROFILE_COMPLETE,
];
const STATUS_CHANGE_VALIDITY = {
    VALID: 'valid',
    INVALID: 'invalid',
    /** If a status change should be updated, however the user is in a state where they cannot be updated,
     *  this will save the record into the CUSTOMER_STATUS_changes table, but won't update the user record. */
    PENDING: 'pending',
};
const USER_STATUSES = {
    ...ESTHETICIAN_STATUSES,
    ...CUSTOMER_STATUSES,
};
const VALID_ESTHETICIAN_STATUSES = Object.values(ESTHETICIAN_STATUSES);
const VALID_CUSTOMER_STATUSES = Object.values(CUSTOMER_STATUSES);
const VALID_USER_STATUSES = [
    ...VALID_CUSTOMER_STATUSES,
    ...VALID_ESTHETICIAN_STATUSES,
];
const VALID_STATUSES_BY_ROLE = {
    [ROLES.ADMIN]: [],
    [ROLES.CUSTOMER]: VALID_CUSTOMER_STATUSES,
    [ROLES.ESTHETICIAN]: VALID_ESTHETICIAN_STATUSES,
    [ROLES.ESTHETICIAN_STUDENT]: VALID_ESTHETICIAN_STATUSES,
    [ROLES.ESTHETICIAN_PENDING]: VALID_ESTHETICIAN_STATUSES,
};
const VALID_STATUS_CHANGE_OUTCOMES_BY_ROLE = {
    [ROLES.ADMIN]: {},
    [ROLES.CUSTOMER]: VALID_CUSTOMER_STATUS_CHANGE_OUTCOMES,
    [ROLES.ESTHETICIAN]: VALID_ESTHETICIAN_STATUS_CHANGE_OUTCOMES,
    [ROLES.ESTHETICIAN_STUDENT]: VALID_ESTHETICIAN_STATUS_CHANGE_OUTCOMES,
    [ROLES.ESTHETICIAN_PENDING]: VALID_ESTHETICIAN_STATUS_CHANGE_OUTCOMES,
};
const PENDING_STATUS_CHANGE_OUTCOMES_BY_ROLE = {
    [ROLES.ADMIN]: {},
    [ROLES.CUSTOMER]: PENDING_CUSTOMER_STATUS_CHANGE_OUTCOMES,
    [ROLES.ESTHETICIAN]: PENDING_ESTHETICIAN_STATUS_CHANGE_OUTCOMES,
    [ROLES.ESTHETICIAN_PENDING]: PENDING_ESTHETICIAN_STATUS_CHANGE_OUTCOMES,
};
const ESTHETICIAN_INACTIVE_DAYS_THRESHOLD = 30;
const CUSTOMER_INACTIVE_DAYS_THRESHOLD = 90;

const isValidStatusForRole = (role, requestedStatus) => VALID_STATUSES_BY_ROLE[role].includes(requestedStatus);
const isValidOutcomeForRole = (role, currentStatus, requestedStatus) => {
    var _a, _b, _c;
    if (!currentStatus)
        return true;
    return ((_c = (_b = (_a = VALID_STATUS_CHANGE_OUTCOMES_BY_ROLE === null || VALID_STATUS_CHANGE_OUTCOMES_BY_ROLE === void 0 ? void 0 : VALID_STATUS_CHANGE_OUTCOMES_BY_ROLE[role]) === null || _a === void 0 ? void 0 : _a[currentStatus]) === null || _b === void 0 ? void 0 : _b.includes(requestedStatus)) !== null && _c !== void 0 ? _c : false);
};
const isPendingOutcomeForRole = (role, currentStatus, requestedStatus) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = PENDING_STATUS_CHANGE_OUTCOMES_BY_ROLE === null || PENDING_STATUS_CHANGE_OUTCOMES_BY_ROLE === void 0 ? void 0 : PENDING_STATUS_CHANGE_OUTCOMES_BY_ROLE[role]) === null || _a === void 0 ? void 0 : _a[currentStatus]) === null || _b === void 0 ? void 0 : _b.includes(requestedStatus)) !== null && _c !== void 0 ? _c : false;
};
const validateUserStatusChange = (role, currentStatus, requestedStatus) => {
    // Ensure the new status is valid
    if (!VALID_USER_STATUSES.includes(requestedStatus))
        return STATUS_CHANGE_VALIDITY.INVALID;
    // Ensure the new status is different from the current status
    if (requestedStatus === currentStatus)
        return STATUS_CHANGE_VALIDITY.INVALID;
    // Ensure the new status is valid for the user's role
    if (!isValidStatusForRole(role, requestedStatus))
        return STATUS_CHANGE_VALIDITY.INVALID;
    // Check if it's in the valid outcome set
    if (isValidOutcomeForRole(role, currentStatus, requestedStatus))
        return STATUS_CHANGE_VALIDITY.VALID;
    // Check if it's in the pending outcome set
    if (isPendingOutcomeForRole(role, currentStatus, requestedStatus))
        return STATUS_CHANGE_VALIDITY.PENDING;
    // If it's not in either set, it's invalid
    return STATUS_CHANGE_VALIDITY.INVALID;
};

const PRODUCT_TAG_TYPES = {
    SKIN_CONCERN: 'Skin Concern',
    KEY_INGREDIENT: 'Key Ingredient',
    SKIN_TYPE: 'Skin Type',
    PREFERENCE: 'Preference'
};
const TAG_TYPE_OPTIONS = [PRODUCT_TAG_TYPES.KEY_INGREDIENT, PRODUCT_TAG_TYPES.PREFERENCE, PRODUCT_TAG_TYPES.SKIN_CONCERN, PRODUCT_TAG_TYPES.SKIN_TYPE];

const TRANSACTION_STATUSES = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    REFUNDED: 'REFUNDED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
};

const USER_TYPES = {
    DIRECT: 'direct',
    PRO: 'pro',
    REFERRED_BY_CLIENT: 'referred_by_client',
    ESTHETICIAN: 'esthetician',
    STAFF: 'staff',
    REFERRED_BY_POMP: 'referred_by_pomp',
    REFERRED_BY_ESTIE: 'referred_by_estie',
    DEMO_CLIENT: 'demo_client',
    GUEST: 'guest',
};
const getUserTypes = (data) => {
    switch (data) {
        case USER_TYPES.DIRECT:
            return USER_TYPES.REFERRED_BY_POMP;
        case USER_TYPES.PRO:
            return USER_TYPES.REFERRED_BY_ESTIE;
        case USER_TYPES.DEMO_CLIENT:
            return USER_TYPES.DEMO_CLIENT;
        case USER_TYPES.GUEST:
            return USER_TYPES.GUEST;
        default:
            return data;
    }
};
const USER_SOURCE_UTM_SOURCES = {
    POMP: 'pomp',
};
const USER_SOURCE_UTM_MEDIUMS = {
    INTEGRATION_SQUARE: 'integration_square',
    INTEGRATION_ZAPIER: 'integration_zapier',
    INVITE: 'invite',
    SHARE_URL: 'share_url',
    FIND_AN_ESTHETICIAN: 'find_an_esthetician',
    DIRECT_REGISTER: 'direct_register',
};
const USER_SOURCE_UTM_CAMPAIGNS = {
    // Square Integration Campaigns
    HISTORICAL_DATA: 'historical_data',
    RECENT_DATA: 'recent_data',
    BOOKING_WEBHOOK: 'booking_webhook',
    // Invite Campaigns
    INVITE_WITH_PRODUCT: 'invite_with_product',
    INVITE_WITHOUT_PRODUCT: 'invite_without_product',
};

const BRANDS = 'Brands';

const DOCUMENT_TYPES = {
    PRIVACY_POLICY: 'privacy policy',
    ESTHETICIAN_AGREEMENT: 'esthetician agreement',
    TERMS_OF_SERVICE: 'tos',
};

const WISHLIST_PRODUCT_SOURCES = {
    CART: 'cart',
    STORE: 'store',
};

class PompServiceContainer {
    constructor(services = []) {
        this.services = services;
    }
    /**
     * Register a service with this container.
     * @param service The service to register.
     */
    registerService(service) {
        this.services.push(service);
    }
    /**
     * Combine all service resolvers into a single object.
     * @returns The resolvers that have been registered with this container.
     */
    getResolvers(legacyResolvers = { Query: {}, Mutation: {} }) {
        return this.services.reduce((acc, service) => {
            const serviceResolvers = service.getResolvers();
            const { Query, Mutation, ...other } = serviceResolvers;
            return {
                ...acc,
                ...other,
                Query: {
                    ...acc.Query,
                    ...Query
                },
                Mutation: {
                    ...acc.Mutation,
                    ...Mutation
                }
            };
        }, legacyResolvers);
    }
}

const SERVICE_AUTH_TYPES = {
    GUEST: 'GUEST', // No authentication required for this route
    ROLE: 'ROLE', // Role based authentiaction
    // USER: 'USER' as const, // User based authentication
};

/**
 * A wrapper that validates that the currently authenticated user is
 * eligible to complete this function and if so executes it.
 *
 * @param func The function to execute if it passes the role check
 * @param auth The auth object
 * @returns The handler function
 */
const serviceAuthenticationWrapper = (func, auth) => (root, args, context) => {
    switch (auth.type) {
        case SERVICE_AUTH_TYPES.ROLE:
            // Wrap and exectue the function.
            return authenticationWrapper(func, auth.config.role)(root, args, context);
        case SERVICE_AUTH_TYPES.GUEST:
            return func({ root, args, context });
    }
};

// By default lock all permissions to the highest standard
const DEFAULT_AUTH = {
    type: SERVICE_AUTH_TYPES.ROLE,
    config: { role: ROLES.ADMIN },
};
const DEFAULT_GUEST_AUTH = {
    type: SERVICE_AUTH_TYPES.GUEST,
};
/**
 * A pomp graphql service that can register the endpoints it requires.
 * TODO: Consider if it's worthwhile adding the graphql schema in here as well and what the lift would be.
 */
class PompService {
    constructor() {
        this.resolvers = [];
    }
    /**
     * Register a resolver for this service.
     *
     * @param resolver The resolver to register
     */
    registerResolver(resolver) {
        // If it's a mutation or a query and it doesn't have auth, add the default auth, otherwise add the default guest auth
        if (!resolver.auth) {
            resolver.auth = resolver.type ? DEFAULT_AUTH : DEFAULT_GUEST_AUTH;
        }
        this.resolvers.push(resolver);
    }
    /**
     * Register a new query resolver for this service.
     *
     * @param query The query to register
     */
    registerQuery(query) {
        this.registerResolver({ ...query, type: 'Query' });
    }
    /**
     * Register a new mutation resolver for this service.
     *
     * @param mutation The mutation to register
     */
    registerMutation(mutation) {
        this.registerResolver({ ...mutation, type: 'Mutation' });
    }
    /**
     * Build out the resolvers for this service.
     *
     * @returns The resolvers that this service has registered.
     */
    getResolvers() {
        return this.resolvers.reduce((acc, { name, resolver, type, auth }) => {
            if (!type) {
                return {
                    ...acc,
                    [name]: resolver,
                };
            }
            const wrappedFunc = serviceAuthenticationWrapper(resolver, auth);
            return {
                ...acc,
                [type]: {
                    ...acc[type],
                    [name]: wrappedFunc,
                },
            };
        }, {
            Query: {},
            Mutation: {},
        });
    }
}

export { ACTIVE_ESTHETICIAN_SUBSCRIPTION_TIERS, ACTIVE_SUBSCRIPTION_STATUSES, ADD_TO_CART_OPTIONS, ASSET_TYPES, AccessDeniedError, BRANDS, BRAND_EDUCATION_FORMATS, BRAND_EDUCATION_PRICE_POINTS, BRAND_EDUCATION_TIME, BRAND_EDUCATION_TYPES, BUSINESS_ROLES, BUSINESS_TIERS, CAMPAIGNS, CART_SOURCE, CLIENT_COUNT, CLIENT_COUNT_OPTIONS, COMMISSION_BONUS_TRIGGER_TYPE, COMMISSION_BONUS_TYPE, COMMISSION_PAYMENT_STATUS, COMMISSION_PLAN_STATUS, COMMISSION_STATUS, COMMISSION_TYPE, CREDIT_STATUSES, CREDIT_TYPES, CREDIT_TYPE_OPTIONS, CURRENT_SURVEY_VERSION, CUSTOMER_INACTIVE_DAYS_THRESHOLD, CUSTOMER_STATUSES, CUSTOMER_STATUSES_DEFAULT, CUSTOMER_STATUSES_DIRECT, CUSTOMER_STATUSES_PRO, DEFAULT_PAGINATION_PAGE, DEFAULT_PAGINATION_SIZE, DEFAULT_PRODUCT_IMAGE, DEFAULT_TIME_ZONE, DISCOUNT_TYPE, DISCOUNT_TYPE_OPTIONS, DOCUMENT_TYPES, EMAIL_TEMPLATE_KEYS, EMAIL_TEMPLATE_SENDERS, ENTITY_TYPE, ENTITY_TYPE_OPTIONS, ESTHETICIAN_INACTIVE_DAYS_THRESHOLD, ESTHETICIAN_ONBOARDING_PAGES, ESTHETICIAN_ONBOARDING_PROGRESS_STATUS, ESTHETICIAN_SAFE_CUSTOMER_STATUSES, ESTHETICIAN_STATUSES, ESTHETICIAN_TAG_TYPES, FEATURE_FLAGS, FEATURE_FLAG_TYPES, HOW_HELPFUL, IMPORT_STATUS, INTEGRATIONS, INTEGRATION_AUTH_TYPES, INVOICE_STATUSES, LICENSE_APPROVAL, LICENSE_STATUSES, NotFoundError, ORDER_COMMISSION, ORDER_NUMBER, ORDER_SHIPMENT_STATUS, PAGINATION_SIZE_LARGE, PENDING_CUSTOMER_STATUS_CHANGE_OUTCOMES, PENDING_ESTHETICIAN_STATUS_CHANGE_OUTCOMES, PENDING_STATUS_CHANGE_OUTCOMES_BY_ROLE, PRODUCT_INTERVAL_OPTIONS, PRODUCT_INTERVAL_OPTIONS_DAILY, PRODUCT_SUBSCRIPTIONS_TIERS, PRODUCT_SUBSCRIPTIONS_TIERS_DAILY, PRODUCT_TAG_TYPES, PompApiError, PompService, PompServiceContainer, RECOMMENDATION_STATUSES, ROLES, ROLE_OPTIONS, ROLE_PERMISSION_LEVELS, ROUTINE_STATUSES, ROUTINE_TIMING, SERVICES_OPTIONS, SERVICE_AUTH_TYPES, SHIPPING_CARRIERS, SPECIALTY_OPTIONS, STATUS_CHANGE_VALIDITY, SUBSCRIPTION_INTERVALS, SUBSCRIPTION_STATUSES, SUBSCRIPTION_TIERS, SURVEY_QUESTION_SUB_TYPES, SURVEY_QUESTION_TYPES, TAG_TYPE_OPTIONS, TAX_CODE, TIERS, TIER_OPTIONS, TRANSACTION_STATUSES, USER_SOURCE_UTM_CAMPAIGNS, USER_SOURCE_UTM_MEDIUMS, USER_SOURCE_UTM_SOURCES, USER_STATUSES, USER_TYPES, VALID_CUSTOMER_STATUSES, VALID_CUSTOMER_STATUS_CHANGE_OUTCOMES, VALID_ESTHETICIAN_STATUSES, VALID_ESTHETICIAN_STATUS_CHANGE_OUTCOMES, VALID_INTEGRATIONS, VALID_STATUSES_BY_ROLE, VALID_STATUS_CHANGE_OUTCOMES_BY_ROLE, VALID_TIERS_FOR_ROLE, VALID_USER_STATUSES, ValidationError, WISHLIST_PRODUCT_SOURCES, authenticationWrapper, calculateEligibleBonuses, calculateOrderCommissionAmount, convertPagination, decryptString, encryptString, getBaseUserTierFromEstheticianTier, getConfig, getNormalBillingInterval, getNormalPlanName, getQualifiedShortUrl, getSubscriptionChangeType, getTierFromSubscriptionPlan, getTrackingLink, getUserTypes, hasUserPermission, isRoutineValid, validateRolePermission, validateUserStatusChange };
